import { getCoreRowModel } from "@tanstack/react-table"
import type { FC, RefObject } from "react"
import type { CombinedError } from "urql"

import { useSourceChangeColumns } from "../hooks/useSourceChangeColumns"
import type { SourceChangeApprovalRow } from "../types"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"

interface SourceChangeTableProps {
  data: SourceChangeApprovalRow[]
  loading?: boolean
  error?: CombinedError | Error
  containerRef?: RefObject<HTMLDivElement>
  onScroll?: () => void
  onApprove: (sourceChange: SourceChangeApprovalRow) => void
  onReject: (sourceChange: SourceChangeApprovalRow) => void
}

export const SourceChangeTable: FC<SourceChangeTableProps> = ({
  data,
  error,
  loading = false,
  containerRef,
  onScroll,
  onApprove,
  onReject,
}) => {
  const columns = useSourceChangeColumns({ onApprove, onReject })

  return (
    <AerosBaseTable
      error={error}
      features={{
        table: {
          stickyHeader: true,
        },
        tanstackOptions: {
          data,
          columns,
          state: {
            isLoading: loading,
          },
          getCoreRowModel: getCoreRowModel(),
          getRowId: (sourceChange) => sourceChange.record.id,
        },
      }}
      slotProps={{
        container: { ref: containerRef, onScroll },
      }}
      noDataMessage='No pending source changes'
    />
  )
}
